<section>
  @if (showButtons) {
    <div class="button-line">
      <button type="button" class="regular button" (click)="print()">Print</button>
      <!--<button type="button" class="regular button" (click)="email()">Email</button>-->
    </div>
  }
  <div class="content" [innerHtml]="content | keepHtml">
  </div>
</section>
